import React, { useContext, useEffect, useState } from 'react'
import Details_Banner from './deatils-banner/Details_Banner'
import Tour_Details_Tabs from './tour-details-tabs/Tour_Details_Tabs'
import { Context } from '../../../../utils/context';
import { getSinglePackage } from '../../../../utils/apis/packages/Homeapi';
import { useParams } from 'react-router-dom';
import { decodeId } from '../../../../utils/common';
import parse from "html-react-parser"


const Tour_Details = () => {
    const {
        IMG_URL,
    } = useContext(Context);

    const { id } = useParams()

    const [packages, setPackages] = useState();
    const getAllPackages = async () => {
        const res = await getSinglePackage(decodeId(id));

        if (res?.success) {
            setPackages(res?.data);
        } else {
            console.error('Error fetching  data:', res?.error);
        }
    }

    useEffect(() => {
        getAllPackages();
    }, []);
    return (
        <>
            <Details_Banner
                image={IMG_URL + packages?.image}
                name={packages?.name}
                subname={packages?.subname}
                description={parse(packages?.description || "")}
            />
            {packages?.package_details?.length > 0 &&
                <Tour_Details_Tabs result={packages} />
            }
        </>
    )
}

export default Tour_Details